import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_API_BASE_URL: z.url().default('http://localhost:3001'),
    VITE_SENTRY_DSN: z.url().optional(),
    VITE_SENTRY_ENVIRONMENT: z.string().optional(),
    VITE_SENTRY_RELEASE: z.string().optional(),
    VITE_ASSET_BATCH_MAX_COUNT: z.coerce.number().int().positive().default(100),
    VITE_QA_SEED_ENABLED: z
      .enum(['true', 'false'])
      .optional()
      .transform((value) => value === 'true'),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});

if (import.meta.env.PROD && new URL(env.VITE_API_BASE_URL).hostname === 'localhost') {
  throw new Error('VITE_API_BASE_URL must be set to a non-localhost URL in production builds');
}
